<script context="module" lang="ts">
	export function formatStandardDate(inputDate: string): string {
		const parts = inputDate.split('/');

		if (parts.length !== 3) {
			return '';
		}

		const [day, month, year] = parts;

		const formattedDay = day.padStart(2, '0');
		const formattedMonth = month.padStart(2, '0');
		const formattedYear = year;

		return `${formattedYear}-${formattedMonth}-${formattedDay}`;
	}
</script>

<script lang="ts">
	import Input from '$lib/components/Global/Fields/Input.svelte';
	import { type ComponentProps } from 'svelte';
	import { type StepUpdater } from '../../Stepper/stepper';
	import FieldWrapper from './FieldWrapper.svelte';
	import __ from '$lib/stores/TranslationStore';

	export let name: string;
	export let onUpdate: StepUpdater<string> | null = null;

	interface $$Props extends ComponentProps<Input> {
		name: string;
		onUpdate?: StepUpdater<string> | null;
	}

	let value: string = '';

	let type = 'text';

	function dateMask(e: Event, update: (e: Event | string | number | boolean) => void) {
		const elm = e.target as HTMLInputElement;
		let value = elm.value.replace(/\D/g, '');

		if (value.length >= 3 && value.length <= 4) {
			value = value.slice(0, 2) + '/' + value.slice(2);
		} else if (value.length > 4) {
			value = value.slice(0, 2) + '/' + value.slice(2, 4) + '/' + value.slice(4);
		}

		update(value.slice(0, 10));
	}

	const dateFormat = $__('dd/mm/aaaa');

	function getRemainingDateMask(value: string) {
		if (!value) {
			return dateFormat;
		}

		const parts = value.split('/');

		if (parts.length === 1) {
			if (parts[0].length === 0) {
				// dd/mm/aaaa
				return dateFormat;
			} else if (parts[0].length === 1) {
				// d/mm/aaaa
				return dateFormat.slice(1);
			} else if (parts[0].length === 2) {
				// /mm/aaaa
				return dateFormat.slice(2);
			}
		} else if (parts.length === 2) {
			if (parts[1].length === 0) {
				// /mm/aaaa
				return dateFormat.slice(2);
			} else if (parts[1].length === 1) {
				// m/aaaa
				return dateFormat.slice(4);
			} else if (parts[1].length === 2) {
				// /aaaa
				return dateFormat.slice(5);
			}
		} else if (parts.length === 3) {
			if (parts[2].length === 0) {
				// /aaaa
				return dateFormat.slice(5);
			} else if (parts[2].length < 4) {
				return dateFormat.slice(5).slice(parts[2].length);
			}
		}

		if (parts.length === 3 && parts[2].length === 4) {
			return null;
		}

		return null;
	}

	let remainingMask: string | null = dateFormat;
	$: remainingMask = getRemainingDateMask(value);
</script>

<FieldWrapper
	{name}
	{onUpdate}
	let:handleUpdate
	let:error
	on:value={(e) => {
		value = e.detail || '';
	}}
>
	<Input
		inputmode="numeric"
		{name}
		{value}
		{error}
		{type}
		{...$$restProps}
		on:input={(e) => dateMask(e, handleUpdate)}
	>
		<div class:hidden={value === ''} class="opacity-50" slot="after">
			{remainingMask ?? ''}
		</div>
	</Input>
</FieldWrapper>
